import React, { useState } from 'react'

import Checkbox from '../../../../components/Checkbox/Checkbox'
import { Form } from '../../../../components/Form/Form'
import Select from '../../../../components/Select/Select'
import SelectItem from '../../../../components/Select/SelectItem'
import TextField from '../../../../components/TextField/TextField'
import t from '../../../../helpers/i18n'

const numberValidation = (text) =>
  /^[1-9][0-9]*$/.test(text) ? false : t('validations.number_is_invalid')

const NewCompetitionStepSix = ({ usingGroups, data, setFormValid }) => {
  const [rounds, setRounds] = useState()
  const [tieBreaker, setTieBreaker] = useState()
  const [overtime, setOvertime] = useState()
  const [penaltyKicks, setPenaltyKicks] = useState()
  const [globalTieBreaker, setGlobalTieBreaker] = useState()

  const TieBreakerOvertimePenalties = () => {
    return (
      <div>
        <Checkbox
          onChange={(checked) => setOvertime(checked)}
          label={t('labels.Overtime')}
        />
        {overtime && (
          <TextField
            label={t('labels.Minutes')}
            maxLength={3}
            minLength={1}
            onValidation={numberValidation}
            required
          />
        )}
        <Checkbox
          onChange={(checked) => setPenaltyKicks(checked)}
          label={t('labels.Penalty_kicks')}
        />
        {penaltyKicks && (
          <TextField
            label={t('labels.Number_of_penalty_kicks')}
            maxLength={3}
            minLength={1}
            onValidation={numberValidation}
            required
          />
        )}
      </div>
    )
  }

  return (
    <div>
      <h3>{t('titles.New competition - Championship Phase Settings')}</h3>
      <Form data={data} onValidityChange={setFormValid}>
        <Select
          onChange={(value) => setRounds(value)}
          label={t('labels.Rounds')}
          required
        >
          <SelectItem>- {t('select_item.Select rounds')} -</SelectItem>
          <SelectItem value='one'>{t('select_item.One round')}</SelectItem>
          <SelectItem value='two'>
            {t('select_item.Two rounds (home & away matches)')}
          </SelectItem>
        </Select>

        <h4>{t('titles.Tie Breaker Criteria')}</h4>
        {rounds === 'one' && (
          <div>
            <Select
              onChange={(value) => setTieBreaker(value)}
              label={t('labels.Tie breaker')}
              required
            >
              <SelectItem>- {t('select_item.Select_criteria')} -</SelectItem>
              <SelectItem value='overtime'>
                {t('select_item.Overtime_and/or_penalty_kicks')}
              </SelectItem>
              <SelectItem value='match'>{t('select_item.An_additional_match')}</SelectItem>
            </Select>
            {tieBreaker === 'overtime' && <TieBreakerOvertimePenalties />}
          </div>
        )}

        {rounds === 'two' && (
          <div>
            <Select
              onChange={(value) => setTieBreaker(value)}
              label={t('labels.Tie breaker')}
              required
            >
              <SelectItem>- {t('select_item.Select_criteria')} -</SelectItem>
              <SelectItem value='global'>{t('select_item.Global_score')}</SelectItem>
              <SelectItem value='match'>{t('select_item.An_additional_match')}</SelectItem>
            </Select>
            {tieBreaker === 'global' && (
              <div>
                <Select
                  onChange={(value) => setGlobalTieBreaker(value)}
                  label={t('labels.Tie breaker 2')}
                  required
                >
                  <SelectItem>- {t('select_item.Select_criteria')} -</SelectItem>
                  <SelectItem value='away_goals'>
                    {t('select_item.Global_score_with_away_goals')}
                  </SelectItem>
                  <SelectItem value='most_goals'>
                    {t('select_item.Most goals scored in both matches')}
                  </SelectItem>
                </Select>
                {globalTieBreaker === 'away_goals' && (
                  <TieBreakerOvertimePenalties />
                )}
                {globalTieBreaker === 'most_goals' && (
                  <TieBreakerOvertimePenalties />
                )}
              </div>
            )}
          </div>
        )}
      </Form>
    </div>
  )
}

export default NewCompetitionStepSix
